import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { InvestorInitiativeGridComponent } from '../../investor-intel-common-grid/investor-intel-common-grid.component';
import { FilterDto } from '@app/service/search-grid/SearchDto';
import { EndpointConstants } from '@app/services/constants/endpoint.constants';
import { AppConstants } from '@app/app.constants';
import { ExclusionRuleDialogComponent } from './exclusion-rule-dialog/exclusion-rule-dialog.component';
import { InvestorIntelItem } from '@app/dto/InvestorIntelItem';
import { MatDialog } from '@angular/material';

@Component({
  selector: 'app-exclusion-rule',
  templateUrl: './exclusion-rule.component.html',
  styleUrls: ['./exclusion-rule.component.scss']
})
export class ExclusionRuleComponent implements OnInit {
  @Input()
  investorId: number;
  @ViewChild(InvestorInitiativeGridComponent) gridChild: InvestorInitiativeGridComponent;

  displayedGridColumns: string[] = ['name', 'exclusionImpact', 'sectorFocus', 'regionalFocus', 'summary', 'actions'];
  additionalGridFilter: FilterDto[];
  gridRequestUrl = EndpointConstants.ALL_EXCLUSION_RULES;
  gridIdKeyName: string = 'investorIntelItemId';
  gridDeleteUrl = EndpointConstants.EXCLUSION_RULE;
  deleteConfirmationTitle: string = 'Exclusion Rule'
  deleteMessageMappingKey: string = 'name';
  noItemsGridText = 'There are no Exclusion Rules';

  constructor(
    public dialog: MatDialog,
  ) { }

  ngOnInit() {
    this.additionalGridFilter = [
      new FilterDto({ filterPorp: "investorId", value: [this.investorId + ''] }),
      new FilterDto({ filterPorp: "itemType", value: [AppConstants.INVESTOR_INTEL_TYPES.EXCLUSION_RULE] })
    ];
  }

  refreshGridData() {
    this.gridChild.fetchGridData();
  }

  onEditClicked(item: InvestorIntelItem) {
    const dialogRef = this.dialog.open(ExclusionRuleDialogComponent, {
      width: '1000px',
      maxHeight: 'fit-content',
      data: {
        investorId: this.investorId,
        isCreate: false,
        id: item.investorIntelItemId,
        title: 'Edit Rule'
      }
    });
    dialogRef.afterClosed().subscribe(x => {
      this.refreshGridData();
    });
  }

  onAddBtnClick() {
    const dialogRef = this.dialog.open(ExclusionRuleDialogComponent, {
      width: '1000px',
      maxHeight: 'fit-content',
      data: {
        id: this.investorId,
        isCreate: true,
        title: 'Add New Exclusion Rule'
      }
    });
    dialogRef.afterClosed().subscribe(x => {
      this.refreshGridData();
    });
  }

}